import CustomModal from "../../../common/components/modal/CustomDetailModal";
import { Column, Divider, Row, SizedBox } from "../../../common/components/CommonBaseComponents";
import { C2Text, C3Text, C4Text } from "../../../common/components/text/CustomText";
import CustomIcon from "../../../common/components/image/CustomIcon";
import React from "react";
import ParseUtil from "../../../common/utils/ParseUtil";
import Translate from "../../../common/translate/Translate";
import { Theme } from "../../../common/Theme";

const mockData = [
    {
        date: "2025-09-02 09:28:14",
        errorDetail:
            "Checked the device status. Confirmed customer payment. Manual Free Cycle. Confirmed the machine working",
        measures: 'ERROR_DE1, [ "Close the door completely."]',
    },
    {
        date: "2025-09-11 19:28:14",
        errorDetail:
            "Checked the device status. Confirmed customer payment. Manual Free Cycle. Confirmed the machine working",
        measures: 'ERROR_DE1, [ "Close the door completely."]',
    },
    {
        date: "2025-09-02 09:28:14",
        errorDetail:
            "Checked the device status. Confirmed customer payment. Manual Free Cycle. Confirmed the machine working",
        measures: 'ERROR_DE1, [ "Close the door completely."]',
    },
    {
        date: "2025-09-02 09:28:14",
        errorDetail:
            "Checked the device status. Confirmed customer payment. Manual Free Cycle. Confirmed the machine working",
        measures: 'ERROR_DE1, [ "Close the door completely."]',
    },
    {
        date: "2025-09-02 09:28:14",
        errorDetail:
            "Checked the device status. Confirmed customer payment. Manual Free Cycle. Confirmed the machine working",
        measures: 'ERROR_DE1, [ "Close the door completely."]',
    },
    {
        date: "2025-09-02 09:28:14",
        errorDetail:
            "Checked the device status. Confirmed customer payment. Manual Free Cycle. Confirmed the machine working",
        measures: 'ERROR_DE1, [ "Close the door completely."]',
    },
];

function ErrorCard({ dateTime, errorDetail, measures, isLast }) {
    return (
        <>
            <Row>
                <CustomIcon iconName="alert_triangle" size={"18px"} />
                <SizedBox width="4px" />
                <C4Text fontColor={Theme.color.rose500} fontWeight={"500"}>
                    {dateTime} ({ParseUtil.parseDateStringToRelativeTime(dateTime)})
                </C4Text>
            </Row>
            <SizedBox height={"12px"} />
            <SizedBox
                width={"100%"}
                height={"auto"}
                alignItem={"flex-start"}
                justifyContent={"flex-start"}
                borderRadius={"16px"}
                backgroundColor={Theme.color.neutral100}
                overflow={"none"}
                padding={"16px"}
            >
                <C4Text fontColor={Theme.color.gray500} fontWeight={"500"}>
                    {Translate("store.deviceMenu.diagnosis.errorDetail")}
                </C4Text>
                <SizedBox height={"6px"} />
                <C4Text fontWeight={"400"}>{errorDetail}</C4Text>
                <Divider marginTop={"12px"} marginBottom={"12px"} lineStyle={"custom-dotted"} />
                <C4Text fontColor={Theme.color.gray500} fontWeight={"500"}>
                    {Translate("store.deviceMenu.diagnosis.measures")}
                </C4Text>
                <SizedBox height={"6px"} />
                <C4Text fontWeight={"400"}>{measures}</C4Text>
            </SizedBox>
            {!isLast && <SizedBox height={"16px"} />}
        </>
    );
}

function DeviceDiagnosisModal({ isOpen, onClose, device }) {
    return (
        <CustomModal
            title={Translate("store.deviceMenu.diagnosis")}
            isOpen={isOpen}
            onClose={onClose}
            side={"right"}
            width={"552px"}
            maxWidth={"552px"}
            height={"100%"}
        >
            <Row>
                <C3Text fontColor={Theme.color.gray500}>{Translate("store.deviceMenu.type")}</C3Text>
                <SizedBox width={"8px"} />
                <C3Text>{device.type}</C3Text>
                <Divider orientation={"vertical"} height={"16px"} marginLeft={"24px"} marginRight={"12px"} />
                <C3Text fontColor={Theme.color.gray500}>{Translate("store.deviceMenu.name")}</C3Text>
                <SizedBox width={"8px"} />
                <C3Text>{device.name}</C3Text>
                <Divider orientation={"vertical"} height={"16px"} marginLeft={"24px"} marginRight={"12px"} />
                <C3Text fontColor={Theme.color.gray500}>{Translate("store.deviceMenu.model")}</C3Text>
                <SizedBox width={"8px"} />
                <C3Text>{device.model}</C3Text>
            </Row>
            <Divider marginTop={"12px"} thickness={"0"} />
            <C3Text fontColor={Theme.color.gray500}>{Translate("store.deviceMenu.id")}</C3Text>
            <SizedBox width={"8px"} />
            <C3Text>{device.id}</C3Text>
            <SizedBox height={"20px"} width={"100%"} />
            {mockData.length > 0 && (
                <SizedBox
                    width={"100%"}
                    height={"auto"}
                    alignItem={"flex-start"}
                    justifyContent={"flex-start"}
                    borderRadius={"16px"}
                    border={`1px solid ${Theme.color.gray200}`}
                    overflow={"none"}
                    padding={"16px 18px"}
                >
                    {mockData.map((item, index) => (
                        <ErrorCard
                            dateTime={item.date}
                            errorDetail={item.errorDetail}
                            measures={item.measures}
                            isLast={index === mockData.length - 1}
                            key={index}
                        />
                    ))}
                </SizedBox>
            )}
            {mockData.length <= 0 && (
                <Column width={"100%"} height={"75%"} alignItem={"center"} justifyContent={"center"}>
                    <CustomIcon iconName={"alarm"} size={"24px"} />
                    <SizedBox height={"12px"} />
                    <C2Text fontColor={Theme.color.gray500}>{Translate("store.deviceMenu.diagnosis.empty")}</C2Text>
                </Column>
            )}
        </CustomModal>
    );
}

export default DeviceDiagnosisModal;
